import templateUrl from 'emun.auth/forgot-password/forgot-password.htm';
import controller from 'emun.auth/forgot-password/forgot-password.controller';

export default {
    templateUrl,
    controller,
    bindings: {
        callbackUrl: '@',
        loginUrl: '@',
        resetId: '<',
        token: '<',
        onVerificationCodeSent: '&',
        onPasswordChanged: '&',
    },
};
